/*
 * @Author: your name
 * @Date: 2020-07-22 15:08:55
 * @LastEditTime: 2021-07-16 11:12:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /nvoicep-h5/src/main.js
 */
import 'babel-polyfill'//解决安卓4.X兼容性问题
import Vue from 'vue'
import App from './App.vue'
// import HllUI from 'hll-m-ui'//UI组件库
import Store from './store'//使用vuex
import Axios from './axios'//使用axios和mock
import Router from './router'//使用vue-router
import ColorDirective from './directive/v-background-color'//自定义指令
import InputDirective from './directive/v-input-length'
import InputClear from './directive/v-input-clear'

import Config from './config'//配置文件
import SensorsConfig from "./sensors";
import Storage from './assets/lib/storageHelper';
import Vant from 'vant';
import 'vant/lib/index.css';
import '@assets/css/reset.scss';
import '@assets/css/public.scss';
import VConsole from 'vconsole'
import { getUrlParam } from './assets/lib/utils'
// console.log(session, local)
// 引入神策
const sensors = require('./assets/lib/sensorsdata.min.js');
// 引入神策 1.18.8 
const sensors_1_18_8 = require('./assets/lib/sensorsdata.min_1.18.8');

const ENV = process.env.NODE_ENV === 'production' ? '' : '-dev'
if (Config.env) {
  console.log(ENV, Config.env)
  Vue.prototype.$console = new VConsole();
}

if (!window.sensors) {
  window.sensors = sensors;
  if (Config.isXl) {
    let server_url = '';
    switch (Config.env) {
      case '-dev':
        server_url = 'https://uba-stg.xiaolachuxing.com/sa?project=xluser';
        break;
      case '-stg':
        server_url = 'https://uba-stg.xiaolachuxing.com/sa?project=xluser';
        break;
      case '-pre':
        server_url = 'https://uba-stg.xiaolachuxing.com/sa?project=xluser';
        break;
      case ''://prd
        server_url = 'https://uba.xiaolachuxing.com/sa?project=xluser';
      default:
        break;
    }
    // 小拉   

    sensors.init({
      server_url,
      heatmap: {
        //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        //需要 JSSDK 版本号大于 1.7
        clickmap: 'not_collect',
        //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
        //需要 JSSDK 版本号大于 1.9.1
        scroll_notice_map: 'not_collect',
        use_client_time: true,
        send_type: 'beacon'
      }
    });
    console.log(server_url, '小拉埋点上报地址')
  } else {
    // 货运
    sensors.init({
      server_url: `https://uba${ENV}.huolala.cn/sa?project=default`,
      heatmap: {
        //是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        //需要 JSSDK 版本号大于 1.7
        clickmap: 'not_collect',
        //是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
        //需要 JSSDK 版本号大于 1.9.1
        scroll_notice_map: 'not_collect'
      }
    });
    console.log(`https://uba${ENV}.huolala.cn/sa?project=default`, '货运埋点上报地址')
  }

  sensors.quick('isReady', function () {
    // sensors.login(sensors.quick('getAnonymousID'));
    sensors.login(getUrlParam('fid'))
  });
}

sensors.quick('autoTrack', {
  platForm: 'H5'
});
// Vue.use(Axios, {mock: false})
// Vue.use(HllUI)
Vue.use(Store)
Vue.use(Router)
Vue.use(ColorDirective)
Vue.use(InputDirective)
Vue.use(InputClear)
Vue.use(Vant)
Vue.prototype.$axios = Axios
Vue.prototype.$config = Config;
Vue.prototype.$sensors = SensorsConfig;
Vue.prototype.$session = Storage.session;
Vue.prototype.$local = Storage.local;

Vue.prototype.$callNativeFunc = function (params) {
  if (app && app.webcall) {
    app.webcall(JSON.stringify(params))
  } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.app) {
    window.webkit.messageHandlers.app.postMessage(JSON.stringify(params));
  }
}
new Vue({
  el: '#app',
  render: h => h(App),
  router: Router.router,
  store: Store.store
})



// WEBPACK FOOTER //
// ./src/main.js